import { Injectable, EventEmitter, Injector } from '@angular/core';
import { VuCommunicationService } from '../vu/vu-communication.service';
import { IVuConnection } from '../vu/connection/vu-connection.interfaces';

@Injectable()
export class RfidCardReaderService {
  private vuCommunicationService: VuCommunicationService;
  private vuConnection: IVuConnection;

  rfidCardScanned: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    protected injector: Injector,
  ) {
    this.vuCommunicationService = injector.get(VuCommunicationService);
    this.vuConnection = this.vuCommunicationService.vuConnection;
    this.vuConnection.eventRfidCardRead.subscribe((rfidCardCode: string) => this.onRfidCardRead(rfidCardCode));
  }

  onRfidCardRead(barcode: string) {
    this.rfidCardScanned.emit(barcode);
  }
}
